import { QuestionCircleOutlined } from "@ant-design/icons";
import { Button, Divider, Input, Select, Switch, Tooltip, Typography } from "antd";
import { useContext, useEffect, useState } from "react";
import { NewFeatureListContext } from "../Map-marker-list-wrapper";

export const MapMarkerBaseForm = () => {
	const [customAddress, setCustomAddress] = useState("");
	const { selectedItem, detour } = useContext(NewFeatureListContext);
	const [addresses, setAdresses] = useState(selectedItem!.get("addresses")?.map((a: string) => ({ label: a, value: a })));
	const [twoWay, setTwoWay] = useState(selectedItem!.get("twoWay") !== undefined ? !!selectedItem!.get("twoWay") : true);
	const [turnedAround, setTurnedAround] = useState(!!selectedItem!.get("turnedAround"));

	useEffect(() => {
		const updateAdresses = () => {
			setAdresses(selectedItem!.get("addresses")?.map((a: string) => ({ label: a, value: a })));
		};
		selectedItem!.on("change", updateAdresses);
		return () => {
			selectedItem!.un("change", updateAdresses);
		};
	}, []);

	const addItem = (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
		e.preventDefault();
		const addresses = selectedItem!.get("addresses") ?? [];
		const newAdresses = [customAddress, ...addresses];
		selectedItem!.set("addresses", [customAddress, ...addresses]);
		setAdresses(newAdresses.map((a: string) => ({ label: a, value: a })));
	};

	return (
		<form className="grid grid-cols-4 items-center text-right gap-2 mt-2">
			{!detour && (
				<>
					<Typography.Text>
						Adrese{" "}
						<Tooltip title="Norādiet adresi (informatīvi), tā nemaina objekta novietojumu.">
							<QuestionCircleOutlined className="text-gray-500" />
						</Tooltip>{" "}
						:
					</Typography.Text>
					<Select
						className="col-span-3 text-left"
						value={selectedItem?.get("address")}
						options={addresses}
						showSearch
						onChange={(e) => selectedItem!.set("address", e)}
						dropdownRender={(menu) => (
							<>
								{menu}
								<Divider style={{ margin: "8px 0" }} />
								<div className="flex justify-between p-2 gap-2">
									<Input placeholder="Pievienot adresi" onChange={(e) => setCustomAddress(e.target.value)} className="flex-grow" />
									<Button type="text" onClick={addItem}>
										Pievienot
									</Button>
								</div>
							</>
						)}
						placeholder={"Izvēlieties adresi"}
						id={"address"}
					/>
				</>
			)}
			{detour && (
				<>
					<Typography.Text>
						Divvirzienu ceļš{" "}
						<Tooltip title="Norāda vai apbraukšanas maršruts ir izmantojams abos braukšanas virzienos.">
							<QuestionCircleOutlined className="text-gray-500" />
						</Tooltip>{" "}
						:
					</Typography.Text>
					<div className="col-span-3 flex items-start">
						<Switch
							className="col-span-3 bg-[#bfbfbf]"
							id={"twoWay"}
							checked={twoWay}
							onChange={() => {
								setTwoWay(!twoWay);
								selectedItem!.set("twoWay", !twoWay);
							}}
						/>
					</div>
					<Typography.Text className="!leading-snug">
						Mainīt braukšanas virzienu{" "}
						<Tooltip title="Maina apbraukšanas maršruta braukšanas virzienu.">
							<QuestionCircleOutlined className="text-gray-500" />
						</Tooltip>{" "}
						:
					</Typography.Text>
					<div className="col-span-3 flex items-start">
						<Switch
							className="col-span-3 bg-[#bfbfbf]"
							id={"turnedAround"}
							checked={turnedAround}
							onChange={() => {
								setTurnedAround(!turnedAround);
								selectedItem!.set("turnedAround", !turnedAround);
							}}
						/>
					</div>
				</>
			)}
		</form>
	);
};
